import { setView } from '../../runtime/shell/navigation.runtime.js';
import { memo } from 'preact/compat';
import { useKUniView } from '../../hooks/useKUniView.js';

const ConnectionState = memo(function ConnectionState() {
  return <span class="workspace-kicker" id="connection-state" data-ui-text="shell.sync.ok" />;
});

const HeadActionsHost = memo(function HeadActionsHost() {
  return <div class="head-actions" id="head-actions" />;
});

const PersistentActions = memo(function PersistentActions() {
  return (
    <div class="persistent-actions">
      <button class="icon-button guest-exit-shortcut" id="guest-exit-shortcut" type="button" data-ui-text-title="shell.guest.logout" data-ui-text-aria="shell.guest.logout" hidden>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 17l5-5-5-5M15 12H3M14 3h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5" /></svg>
      </button>
      <button class="icon-button" id="personalization-button" type="button" onClick={() => void setView('settings')} data-ui-text-title="shell.personalize" data-ui-text-aria="shell.personalize">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h2M10 17h10M14 4v6M6 14v6" /></svg>
      </button>
    </div>
  );
});

const GuestMobileGroup = memo(function GuestMobileGroup() {
  return (
    <div class="guest-mobile-group" id="guest-mobile-group" hidden>
      <label for="guest-group-selector" data-ui-text="shell.mobile.group" />
      <button class="guest-group-button" id="guest-group-selector" type="button" aria-haspopup="dialog" aria-label="Выбрать группу для просмотра">
        <span data-current-group-short="">Группа</span>
        <b aria-hidden="true">⌄</b>
      </button>
    </div>
  );
});

export function WorkspaceHeader() {
  const { title, subtitle, phase } = useKUniView();

  return (
    <header class="workspace-head" data-view-phase={phase}>
      <div class="workspace-heading">
        <ConnectionState />
        <h2 id="view-title">{title}</h2>
        <p id="view-subtitle">{subtitle}</p>
      </div>
      <div class="workspace-actions">
        <GuestMobileGroup />
        <HeadActionsHost />
        <PersistentActions />
      </div>
    </header>
  );
}
